import {
	PASSTHRU_SET_FOUND_PARTNER,
	PASSTHRU_SET_FOUND_PARTNER_LINK,
	PASSTHRU_TOGGLE_REDIRECT_IMMEDIATELY,
	SET_DURATION_DETECT_REDIRECT_LINK,
	SET_TICKET_DATA,
} from '../actions/types';

const initialState = {
	foundLink: null,
	redirectImmediately: false,
	ticketData: {},
	durationDetectRedirectLink: 0,
	partner: '',
};

const passthruReducer = (state = initialState, action) => {
	switch (action.type) {
		case PASSTHRU_SET_FOUND_PARTNER_LINK:
			return {
				...state,
				foundLink: action.payload,
			};
		case PASSTHRU_SET_FOUND_PARTNER:
			return {
				...state,
				partner: action.payload,
			};
		case PASSTHRU_TOGGLE_REDIRECT_IMMEDIATELY:
			return {
				...state,
				redirectImmediately: action.payload,
			};
		case SET_TICKET_DATA:
			return {
				...state,
				ticketData: action.payload,
			};
		case SET_DURATION_DETECT_REDIRECT_LINK: {
			return {
				...state,
				durationDetectRedirectLink: action.payload,
			};
		}

		default:
			return state;
	}
};
export default passthruReducer;
